import { useEffect } from 'react'

// TODO implement status handlers

export const Status: React.FC<{
  cause?: string
  info?: string
  success?: string
  error?: string
  warning?: string
  handler?: { label: string; callback: Function }
  reset?: () => void
}> = (props) => {
  const { cause, info, success, error, warning, reset } = props

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      {info && (
        <div className='highlight highlight-banner highlight-blue'>
          <span className='material-symbols-rounded'>info</span>
          <em>Info:</em>
          <div>
            <span>
              {cause && cause + ' - '}
              {info}
            </span>
            {/* {handler && (
              <span className='span-a' onClick={() => handler.callback()}>
                {handler.label}
              </span>
            )} */}
          </div>
          {reset && (
            <span className='material-symbols-rounded material-close' onClick={reset} title='Close'>
              close
            </span>
          )}
        </div>
      )}
      {success && (
        <div className='highlight highlight-banner highlight-green'>
          <span className='material-symbols-rounded'>download_done</span>
          <em>Success:</em>
          <div>
            <span>
              {cause && cause + ' - '}
              {success}
            </span>
          </div>
          {reset && (
            <span className='material-symbols-rounded material-close' onClick={reset} title='Close'>
              close
            </span>
          )}
        </div>
      )}
      {error && (
        <div className='highlight highlight-banner highlight-red'>
          <span className='material-symbols-rounded'>front_hand</span>
          <em>Error:</em>
          <div>
            <span>
              {cause && cause + ' - '}
              {error}
            </span>
          </div>
          {reset && (
            <span className='material-symbols-rounded material-close' onClick={reset} title='Close'>
              close
            </span>
          )}
        </div>
      )}
      {warning && (
        <div className='highlight highlight-banner highlight-orange'>
          <span className='material-symbols-rounded'>info</span>
          <em>Info:</em>
          <div>
            <span>
              {cause && cause + ' - '}
              {warning}
            </span>
          </div>
          {reset && (
            <span className='material-symbols-rounded material-close' onClick={reset} title='Close'>
              close
            </span>
          )}
        </div>
      )}
    </>
  )
}
